import React from "react";
import { motion } from "framer-motion";
import { CopyButton, resolveCopyText, shouldShowCopy } from "./copyUtils";
import {
  StatListWrapper,
  StatGroup,
  StatGroupTitle,
  StatRow,
  StatLabel,
  StatValue,
  StatCopySlot,
  StatGrid,
} from "./styles";

function Row({ item, index }) {
  const resolved = resolveCopyText(item.value, item.copyText);
  const showCopy = shouldShowCopy(resolved);

  return (
    <StatRow
      as={motion.div}
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.28, delay: 0.02 * index, ease: [0.16, 1, 0.3, 1] }}
    >
      <StatLabel>{item.label}</StatLabel>
      <StatValue $tone={item.valueTone}>{item.value}</StatValue>
      <StatCopySlot>
        {showCopy && <CopyButton text={String(resolved)} label={item.label} compact />}
      </StatCopySlot>
    </StatRow>
  );
}

export default function StatList({ groups, columns = 1 }) {
  return (
    <StatListWrapper>
      {groups.map((group, groupIndex) => (
        <StatGroup
          key={group.title}
          as={motion.div}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.05 * groupIndex, ease: [0.16, 1, 0.3, 1] }}
        >
          <StatGroupTitle>{group.title}</StatGroupTitle>
          <StatGrid $columns={columns}>
            {group.items.map((item, index) => (
              <Row key={item.label} item={item} index={index} />
            ))}
          </StatGrid>
        </StatGroup>
      ))}
    </StatListWrapper>
  );
}
